module.exports = __webpack_public_path__ + "img/sseapp_logo.88bddf7e.png";